





















































































































































































































































































































































































































































































































import Vue from 'vue'
import { config } from '../config'
import { headings } from '../config'
import { details } from '../details'

export default Vue.extend({
    name: 'House1',
    props: ['step1', 'step2', 'step3'],
    data: () => ({
        dialog: false,
        tile: false,
        replace: "Install sarking across whole entire roof. Install new tile battens fixed to rafters with one no. 14 type 17 screw. Refix tiles with each tile mechanically fixed with tile clips according to manufacturer’s specifications. ",
        component: 'cladding',
        parts: [
            {
                title: "The Roof Cladding",
                image: "2.png",
                text: "Wind pressures are applied to the roof cladding and forces are then transmitted through all the connections below it. Very high uplift forces are experienced at the edges of the roof.​",
                component: 'cladding',
                disabled: false,
                visible: true,
            },
            {
                title: "Ridgeline",
                image: "1.png",
                text: "The ridgeline connects the two sides of the roof together and experiences high uplift forces as wind moves over the apex of the roof​.",
                component: 'ridgeline',
                disabled: false,
                visible: true,
            },
            {
                title: "Internal Roof Connections",
                image: "7.png",
                text: "  ",
                component: 'internal',
                disabled: false,
                visible: true,

            },
            {
                title: "Roof to Wall Connections",
                image: "4.png",
                text: "These connections experience very high uplift forces as wind uplift forces try to lift the entire roof from the walls.​",
                component: 'wall',
                disabled: false,
                visible: true,

            }

        ],
        details: config,
        headings: headings,
    }),
    mounted() {
        if(this.step2 == '0') {
            this.tile = true;
        }
        //if(this.step3 == '1') {
            //this.details[this.step3][this.step2][this.step1]['cladding'].description = this.replace;
        //}

    }
})
